/*
 * @providesModule MergePromptModal
 */
import React from 'react';
import {DialogV3} from 'DialogV3';
import {View, Text} from 'react-native';
import {SkillzButton} from '@skillz-rn/atoms';
import ThemeOverrideProps from 'ThemeOverrideProps';
import {_m} from 'INTL';
import ModalNavigationController from 'ModalNavigationController';

const {fontBold} = ThemeOverrideProps.sheetStyles;

interface MergePromptModalProps {
  onContinue: () => void;
}

const MergePromptModal: React.FC<MergePromptModalProps> = ({onContinue}) => {
  return (
    <DialogV3 showCloseButton={false}>
      <View style={{marginTop: -10, paddingBottom: 20}}>
        <Text
          style={{
            fontSize: 18,
            color: '#000',
            ...fontBold,
            marginBottom: 10,
            marginHorizontal: -10,
            textAlign: 'center',
          }}
          allowFontScaling={false}
        >
          {_m('Looks like you already have an account with us.')}
        </Text>
        <Text style={{fontSize: 14, color: '#000', textAlign: 'center'}} allowFontScaling={false}>
          {_m("You'll need to merge your accounts before making this bank deposit.")}
        </Text>
      </View>
      <SkillzButton
        text={_m('Continue')}
        size={'L'}
        branding='Game'
        type='Tertiary'
        containerStyle={{marginTop: 20, marginBottom: 20}}
        onPress={() => {
          ModalNavigationController.hideModal();
          onContinue();
        }}
      />
    </DialogV3>
  );
};

export default MergePromptModal;
